import { useEffect, useState } from "react";

import { ActionCodeContextProvider } from "~/contexts/action-code-context-provider";
import { useAuthContext } from "~/contexts/auth";

import GuestReturnYourOrderStep2 from "./guest-return-your-order-step-2";
import GuestTrackYourOrderStep1 from "./guest-track-your-order-step-1";

enum GuestReturnYourOrderSteps {
  Step1 = "Step1",
  Step2 = "Step2",
}

export default function GuestReturnYourOrder() {
  const [currentStep, setCurrentStep] = useState<GuestReturnYourOrderSteps>(GuestReturnYourOrderSteps.Step1);
  const { guestTrackingToken } = useAuthContext();

  useEffect(() => {
    if (guestTrackingToken) {
      setCurrentStep(GuestReturnYourOrderSteps.Step2);
    }
  }, [guestTrackingToken]);

  const goToNextStep = () => {
    setCurrentStep(GuestReturnYourOrderSteps.Step2);
  };

  const goToPrevStep = () => {
    setCurrentStep(GuestReturnYourOrderSteps.Step1);
  };

  const steps = {
    [GuestReturnYourOrderSteps.Step1]: <GuestTrackYourOrderStep1 mode="return" onNext={goToNextStep} />,
    [GuestReturnYourOrderSteps.Step2]: <GuestReturnYourOrderStep2 onPrev={goToPrevStep} />,
  };

  return (
    <ActionCodeContextProvider>
      <div>{steps[currentStep]}</div>
    </ActionCodeContextProvider>
  );
}
